import React from "react";
import { StyleSheet, Text, View } from "react-native";
import CustomIcon from "./CustomIcon";
import { STYLES } from "../assets/styles";
import Badge from "./Badge";
import { connect } from "react-redux";

function Header({
  backButton = false,
  title = "",
  rightIcons,
  navigation,
  cartItems = [],
}) {
  const defaultRightButtons = [
    // { type: "Ionicons", name: "search" },
    {
      type: "Fontisto",
      name: "shopping-bag-1",
      badgeValue: cartItems.length,
      onPress: () => {
        navigation.navigate("tabs", {
          screen: "cart",
          params: { screen: "cartscreen" },
        });
      },
    },
    {
      type: "FontAwesome",
      name: "user-circle-o",
      onPress: () => {
        navigation.navigate("tabs", {
          screen: "profile",
          params: { screen: "profilescreen" },
        });
      },
    },
  ];
  rightIcons = rightIcons || defaultRightButtons;
  return (
    <View style={styles.container}>
      <View style={styles.left}>
        {backButton ? (
          <CustomIcon
            type="AntDesign"
            name="left"
            style={styles.leftIcon}
            onPress={() => navigation.goBack()}
          />
        ) : (
          <CustomIcon
            type="AntDesign"
            name="filter"
            style={styles.leftIcon}
            onPress={() => {
              navigation.toggleDrawer();
            }}
          />
        )}
        <View style={{ justifyContent: "center", paddingLeft: 10, flex: 1 }}>
          <Text style={styles.title}>{title}</Text>
        </View>
      </View>
      <View style={styles.rightIcons}>
        {rightIcons.map(({ badgeValue, type, name, onPress }, index) => (
          <View
            key={index + "sd"}
            style={{
              paddingHorizontal: 5,
              marginHorizontal: 5,
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CustomIcon
              style={styles.icon}
              onPress={onPress}
              type={type}
              name={name}
            />
            {badgeValue ? (
              <Badge
                value={badgeValue}
                size="small"
                style={{ position: "absolute", right: 0 }}
              />
            ) : null}
          </View>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 10,
    height: "7%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  left: {
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
  },
  leftIcon: { color: STYLES.colors.fontColor },
  title: {
    fontSize: STYLES.fontSizes.large,
    textTransform: "capitalize",
    fontWeight: "bold",
    color: STYLES.colors.fontColor,
  },
  rightIcons: {
    flexDirection: "row",
    height: "100%",
  },
  icon: {
    fontSize: STYLES.fontSizes.large,
    color: STYLES.colors.fontColor,
  },
});

const mapStateToProps = (state) => ({
  cartItems: state.cart.items,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
